import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { dynamicWrapper } from "hzero-front/lib/utils/router";
var cardsConfig = [{
  // 公司卡片
  code: 'HFINS.COMPANY',
  component: function () {
    var _component = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./companyCard/CompanyCard");
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function component() {
      return _component.apply(this, arguments);
    }

    return component;
  }()
}, {
  // 我的审批事项卡片
  code: 'HFINS.APPLICATION_ISSUES',
  component: function () {
    var _component2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./approvalCard/Approval");
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function component() {
      return _component2.apply(this, arguments);
    }

    return component;
  }()
}, {
  // 常用功能卡片
  code: 'CommonFunctionsCard',
  component: function () {
    var _component3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./CommonFunctionsCard/CommonFunctionsCard");
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function component() {
      return _component3.apply(this, arguments);
    }

    return component;
  }()
}, {
  // 我的申请
  code: 'HFINS.REQUISITION',
  component: function () {
    var _component4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./ExpRequisitionListCard/ExpRequisitionListCard");
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function component() {
      return _component4.apply(this, arguments);
    }

    return component;
  }()
}, {
  // 我的借款
  code: 'HFINS.BALANCE',
  component: function () {
    var _component5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./BalanceCard/BalanceCard");
              }));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function component() {
      return _component5.apply(this, arguments);
    }

    return component;
  }()
}, {
  // 个人信息
  code: 'HFINS.SELF_INFO',
  component: function () {
    var _component6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./PersonalInfCard/PersonalInfCard");
              }));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function component() {
      return _component6.apply(this, arguments);
    }

    return component;
  }()
}, {
  // 报销
  code: 'HFINS.REIMBURSEMENT',
  component: function () {
    var _component7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./ReimbursementCard/ReimbursementCard");
              }));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function component() {
      return _component7.apply(this, arguments);
    }

    return component;
  }()
}, {
  // 审核
  code: 'HFINS.REVIEW',
  component: function () {
    var _component8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./Review/Review");
              }));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function component() {
      return _component8.apply(this, arguments);
    }

    return component;
  }()
}, {
  // 首页
  code: 'HFINS.HOME_PAGE',
  component: function () {
    var _component9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", dynamicWrapper(window.dvaApp, [], function () {
                return import("./HomePageCard/HomePageCard");
              }));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function component() {
      return _component9.apply(this, arguments);
    }

    return component;
  }()
}];
export default cardsConfig;